import React from "react";
import {
  FaLocationDot,
  FaPhone,
  FaFacebook,
  FaLinkedin,
} from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { AiFillInstagram } from "react-icons/ai";
import Bhim from "../assets/payment/bhim.png";
import Master from "../assets/payment/master.png";
import Payu from "../assets/payment/payU.png";
import Paypal from "../assets/payment/paypal.png";
import Razor from "../assets/payment/razor.jpg";
import Stripe from "../assets/payment/stripe.png";

const Footer = () => {
  return (
    <div
      id="footer"
      className="flex flex-col bg-black gap-6 pt-20 pb-10 justify-center items-center"
    >
      {/* Main Content */}
      <div className="flex flex-col md:flex-row md:gap-28 gap-10 w-full max-w-6xl items- justify-center">
        {/* Location Section */}
        <div className="flex flex-col justify-center items-center text-center">
          <FaLocationDot className="text-white text-4xl" />
          <h1 className="text-white uppercase font-bold pt-4">
            Office Location
          </h1>
          <p className="text-gray-200 pt-4 leading-loose max-w-72">
            Office No. 03, 2nd Floor, Aykon Tower, Sector 135, Noida-201304
          </p>
        </div>

        {/* Contact Section */}
        <div className="flex flex-col justify-center items-center text-center">
          <FaPhone className="text-white text-3xl" />
          <h1 className="text-white uppercase font-bold pt-4">Contact Us</h1>
          <p className="text-white text-xl pt-5 pb-8">+91 88 26 83 18 43</p>
          {/* <p className="text-white text-xl pt-4">+91 88 26 83 18 43</p> */}
        </div>

        {/* Email Section */}
        <div className="flex flex-col justify-center items-center text-center">
          <MdEmail className="text-white text-3xl" />
          <h1 className="text-white uppercase font-bold pt-4">Email</h1>
          <p className="text-gray-200 text-xl pt-5 pb-9">Krisoft03@gmail.com</p>
          {/* <p className="text-gray-200 text-xl pt-2">Krisoft03@gmail.com</p> */}
        </div>
      </div>

      {/* Social Icons */}
      <div className="flex flex-row gap-6 mt-6 justify-center items-center">
        <a
          href="https://www.facebook.com/people/Thekrisoft-Corporation/100067484018279/"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook className="text-white text-3xl cursor-pointer" />
        </a>
        <a
          href="https://www.linkedin.com/in/om-hari-831683142?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
          aria-label="LinkedIn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin className="text-white text-3xl cursor-pointer" />
        </a>
        <a
          href="https://www.instagram.com/thekrisoftcorporation/"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AiFillInstagram className="text-white text-4xl cursor-pointer" />
        </a>
      </div>

      {/* Footer Text */}
     
      <div className="flex flex-col items-center gap-4 sm:gap-6">
        <p className="text-white text-lg font-semibold text-center">
          We Accept
        </p>
        <div className="flex flex-wrap justify-center sm:justify-start gap-2">
          {[Bhim,Master, Stripe, Razor, Payu, Paypal].map((image, index) => (
            <img
              key={index}
              src={image}
              alt="payment"
              className="w-12 h-8 sm:w-14 sm:h-9 rounded-lg p-1"
            />
          ))}
        </div>
      </div>
      <div className="flex flex-col items-center border-t border-white pt-4">
        <h1 className="text-white text-center text-sm">
          All Rights Reserved. thekrisoft Corporation 2012 - {new Date().getFullYear()}
        </h1>
      </div>
    </div>
  );
};

export default Footer;
